import { Component, OnInit } from '@angular/core';
import { environment } from 'src/main/resources/static/angular2/environments/environment';
import { PHONE_NUMBER_LIST } from '../../constants/phone-numbers.const';
import { DomainNameParserService } from '../../services/domain-name-parser.service';
import { BCBS_FOOTER_LIST } from "../../constants/bcbs-footers.const";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  private readonly memberPortalHost;
  private readonly LEGAL_PRIVACY_PATH = '/legalAndPrivacy';
  private readonly FAQ_PATH = '/faq';
  private readonly CONTACT_US_PATH = '/contactUs';

  readonly faxNumber = '1-877-404-6457'
  customerServicePhone: string;
  footerText: string;

  constructor(private domainNameParserService: DomainNameParserService) {
    this.memberPortalHost = environment.memberPortal.host[domainNameParserService.getState()];
    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
    this.footerText = BCBS_FOOTER_LIST[this.domainNameParserService.getState()];
  }

  ngOnInit(): void {
  }

  getLegalPrivacyLink(): string {
    return "#!" + this.LEGAL_PRIVACY_PATH;
  }

  getFaqLink(): string {
    return "#!" + this.FAQ_PATH;
  }

  getContactUsLink(): string {
    return this.memberPortalHost + this.CONTACT_US_PATH;
  }
}
